export default __webpack_public_path__ + "static/media/change-password.75f85fd4.svg";